import {scaleLinear as $8JHTY$scaleLinear, scaleOrdinal as $8JHTY$scaleOrdinal} from "d3-scale";
import {createContext as $8JHTY$createContext, useContext as $8JHTY$useContext, Component as $8JHTY$Component, useMemo as $8JHTY$useMemo, useCallback as $8JHTY$useCallback} from "react";
import $8JHTY$macrostrathyper from "@macrostrat/hyper";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;




var $hdAJm = parcelRequire("hdAJm");
const $4ab230c45ea1ca08$export$8878fe30827b59a6 = (0, $8JHTY$createContext)({
    scale: (0, $8JHTY$scaleLinear)(),
    scaleClamped: (0, $8JHTY$scaleLinear)().clamp(true),
    width: 0,
    divisions: [],
    grainSizes: [],
    grainsizeScale: (d)=>40,
    xScale: null,
    widthForDivision: (d)=>0,
    pixelsPerMeter: 1,
    zoom: 1
});
function $4ab230c45ea1ca08$export$15b77c63191ccb3f({ children: children, width: width, grainSizes: grainSizes = [], grainsizeScale: grainsizeScale = (d)=>40, xScale: xScale }) {
    const ctx = (0, $8JHTY$useContext)((0, $hdAJm.ColumnContext));
    return (0, $8JHTY$macrostrathyper)($4ab230c45ea1ca08$export$8878fe30827b59a6.Provider, {
        value: {
            ...ctx,
            width: width,
            grainSizes: grainSizes,
            grainsizeScale: grainsizeScale,
            xScale: xScale,
            widthForDivision: (d)=>width
        }
    }, children);
}
class $4ab230c45ea1ca08$export$e5a3fc518bbfccdb extends (0, $8JHTY$Component) {
    static #_ = this.contextType = (0, $hdAJm.ColumnContext);
    render() {
        let { domain: domain, range: range, width: width, children: children } = this.props;
        if (range == null) range = [
            0,
            width
        ];
        const xScale = (0, $8JHTY$scaleLinear)().domain(domain).range(range);
        return (0, $8JHTY$macrostrathyper)($4ab230c45ea1ca08$export$15b77c63191ccb3f, {
            ...this.context,
            xScale: xScale,
            width: width,
            children: children
        });
    }
}
function $4ab230c45ea1ca08$export$66a95965bfbc151f({ width: width, grainSizes: grainSizes = [
    "ms",
    "s",
    "vf",
    "f",
    "m",
    "c",
    "vc",
    "p"
], grainsizeScaleStart: grainsizeScaleStart = 50, grainsizeScaleRange: grainsizeScaleRange, tickPositions: tickPositions, children: children }) {
    /**
  Right now this provides a ColumnLayoutContext
  but it could be reworked to provide a
  separate "GrainsizeLayoutContext" if that seemed
  appropriate.
  */ if (grainsizeScaleRange == null) console.warn("GrainsizeLayoutProvider: grainsizeScaleStart and width are deprecated in favor of grainsizeScaleRange");
    grainsizeScaleRange ?? (grainsizeScaleRange = [
        grainsizeScaleStart,
        width
    ]);
    const divisions = (0, $hdAJm.useColumnDivisions)();
    const grainsizeScale = (0, $8JHTY$useMemo)(()=>{
        const scale = (0, $8JHTY$scaleLinear)().domain([
            0,
            grainSizes.length - 1
        ]).range(grainsizeScaleRange);
        tickPositions ?? (tickPositions = grainSizes.map((d, i)=>scale(i)));
        return (0, $8JHTY$scaleOrdinal)().domain(grainSizes).range(tickPositions);
    }, [
        grainSizes,
        grainsizeScaleRange,
        tickPositions
    ]);
    // This function should probably be moved up a level
    const grainsizeForDivision = (0, $8JHTY$useCallback)((division)=>{
        let ix = divisions.indexOf(division);
        // Search backwards through divisions
        while(ix > 0){
            const { grainsize: grainsize } = divisions[ix];
            if (grainsize != null) return grainsize;
            ix -= 1;
        }
    }, [
        divisions
    ]);
    const widthForDivision = (0, $8JHTY$useCallback)((division)=>{
        if (division == null) return width;
        return grainsizeScale(grainsizeForDivision(division));
    }, [
        grainsizeForDivision,
        grainsizeScale,
        width
    ]);
    // This is slow to run each iteration
    return (0, $8JHTY$macrostrathyper)($4ab230c45ea1ca08$export$15b77c63191ccb3f, {
        width: width,
        grainSizes: grainSizes,
        grainsizeScale: grainsizeScale,
        grainsizeScaleStart: grainsizeScaleStart,
        grainsizeScaleRange: grainsizeScaleRange,
        grainsizeForDivision: grainsizeForDivision,
        widthForDivision: widthForDivision
    }, children);
}
const $4ab230c45ea1ca08$export$b95655e575bb494e = ()=>(0, $8JHTY$useContext)($4ab230c45ea1ca08$export$8878fe30827b59a6);


//# sourceMappingURL=layout.c9624adb.js.map
